/* eslint-disable default-param-last, no-prototype-builtins */
import * as actionTypes from './types';

function setSchedule(state, action) {
    const {
        id,
    } = action.meta;

    return {
        ...state,
        [id]: action.payload,
    };
}

const reducerFunctions = {
    [actionTypes.SET_SCHEDULE]: setSchedule,
};

export default function reducer(state = {}, action) {
    if (!reducerFunctions.hasOwnProperty(action.type)) {
        return state;
    }
    return reducerFunctions[action.type](state, action);
}
